import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import QuickAccess from './QuickAccess';
import Search from './search/Search';
import NotifiMaque from './notifi-maque/NotifiMaque';
import './middle.scss';

class Middle extends React.PureComponent {
  state = {
    refreshIndex: 0,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { timeOffset } = this.props;
    if (timeOffset !== null && timeOffset !== prevProps.timeOffset) {
      this.refreshAt(8, 30);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutReload);
  }

  refreshAt = (hour, minute) => {
    const { timeOffset } = this.props;
    const now = new Date();
    const destTime = new Date();
    destTime.setHours(hour, minute, 0, 0);
    destTime.setSeconds(destTime.getSeconds() + timeOffset);
    const timeout = destTime.getTime() - now.getTime();
    if (timeout < 0) {
      return;
    }
    this.timeoutReload = setTimeout(() => {
      this.setState({
        refreshIndex: this.state.refreshIndex + 1,
      });
    }, timeout);
  };

  render() {
    const { refreshIndex } = this.state;
    return (
      <div className="top-middle float-left">
        <div className="">
          <QuickAccess />
          <div className="">
            <div className="search-and-maque">
              <Search />
              <NotifiMaque key={refreshIndex} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  timeOffset: state[COMMON_REDUCER_NAME].timeOffset,
});

export default connect(mapStateToProps)(Middle);
